import React from 'react';
import { UserCircleIcon as HeroUserCircleIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type UserCircleIconProps = Omit<IconProps, 'children'>;

export const UserCircleIcon: React.FC<UserCircleIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroUserCircleIcon />
        </Icon>
    );
};
